module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-4",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("CHAPTER III.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("userti")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Seti rose, stretching out his arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“That is finished,” he said, “as everything finishes, and for once I am sorry. Now what next? Sleep, I suppose, in which all ends, or perhaps you would say all begins.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("As he spoke the curtains at the end of the room were drawn and between them appeared the chamberlain, Pambasa, holding his gold-tipped wand ceremoniously before him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“What is it now, man?” asked Seti. “Can I not even sup in peace? Stay, before you answer tell me, do things end or begin in sleep? The learned Ana and I differ on the matter and would hear your wisdom. Bear in mind, Pambasa, that before we are born we must have slept, since of that time we remember nothing, and after we are dead we certainly seem to sleep, as any who have looked on mummies know. Now answer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The chamberlain stared at the wine flask on the table as though he suspected his master of having drunk too much. Then in a hard official voice he said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“She comes! She comes! She comes, offering greetings and adoration to the Royal Son of Ra.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Does she indeed?” asked Seti. “If so, why say it three times? And who comes?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“The high Princess, the heiress of Egypt, the daughter of Pharaoh, your Highness’s royal half-sister, the great lady Userti.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Let her enter then. Ana, stand you behind me. If you grow weary and I give leave you can depart; the slaves will show you your sleeping-place.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Pambasa went, and presently through the curtain appeared a royal-looking lady splendidly apparelled. She was accompanied by four waiting women who fell back on the threshold and were no more seen. The Prince stepped forward, took both her hands in his and kissed her on the brow, then drew back again, after which they stood a moment looking at each other. While they remained thus I studied her who was known throughout the land as the “Beautiful Royal Daughter,” but whom till now I had never seen. In truth I did not think her beautiful, although even had she been clad in a peasant’s robe I should have been sure that she was royal. Her face was too hard for beauty and her black eyes, with a tinge of grey in them, were too small. Also her nose was too sharp and her lips were too thin. Indeed, had it not been for the delicately and finely-shaped woman’s form beneath, I might have thought that a prince and not a princess stood before me. For the rest in most ways she resembled her half-brother Seti, though her countenance lacked the kindliness of his; or rather both of them resembled their father, Meneptah.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Greeting, Sister,” he said, eyeing her with a smile in which I caught a gleam of mockery. “Purple-bordered robes, emerald necklace and enamelled crown of gold, rings and pectoral, everything except a sceptre—why are you so royally arrayed to visit one so humble as your loving brother? You come like sunlight into the darkness of the hermit’s cell and dazzle the poor hermit, or rather hermits,” and he pointed to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Cease your jests, Seti,” she replied in a full, strong voice. “I wear these ornaments because they please me. Also I have supped with our father, and those who sit at Pharaoh’s table must be suitably arrayed, though I have noted that sometimes you think otherwise.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Indeed. I trust that the good god, our divine parent, is well to-night as you leave him so early.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I leave him because he sent me with a message to you.” She paused, looking at me sharply, then asked, “Who is that man? I do not know him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“It is your misfortune, Userti, but one which can be mended. He is named Ana the Scribe, who writes strange stories of great interest which you would do well to read who dwell too much upon the outside of life. He is from Memphis and his father’s name was—I forget what. Ana, what was your father’s name?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“One too humble for royal ears, Prince,” I answered, “but my grandfather was Pentaur the poet who wrote of the deeds of the mighty Rameses.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Is it so? Why did you not tell me that before? The descent should earn you a pension from the Court if you can extract it from Nehesi. Well, Userti, his grandfather’s name was Pentaur whose immortal verses you have doubtless read upon temple walls, where our grandfather was careful to publish them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I have—to my sorrow—and thought them poor, boastful stuff,” she answered coldly.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“To be honest, if Ana will forgive me, so do I. I can assure you that his stories are a great improvement on them. Friend Ana, this is my sister, Userti, my father’s daughter though our mothers were not the same.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I pray you, Seti, to be so good as to give me my rightful titles in speaking of me to scribes and other of your servants.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Your pardon, Userti. This, Ana, is the first Lady of Egypt, the Royal Heiress, the Princess of the Two Lands, the High-priestess of Amon, the Cherished of the Gods, the half-sister of the Heir-apparent, the Daughter of Hathor, the Lotus Bloom of Love, the Queen to be of—Userti, whose queen will you be? Have you made up your mind? For myself I know no one worthy of so much beauty, excellence, learning and—what shall I add—sweetness, yes, sweetness.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Seti,” she said stamping her foot, “if it pleases you to make a mock of me before a stranger, I suppose that I must submit. Send him away, I would speak with you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Make a mock of you! Oh! mine is a hard fate. When truth gushes from the well of my heart, I am told I mock, and when I mock, all say—he speaks truth. Be seated, Sister, and talk on freely. This Ana is my sworn friend who saved my life but now, for which deed perhaps he should be my enemy. His memory is excellent also and he will remember what you say and write it down afterwards, whereas I might forget. Therefore, with your leave, I will ask him to stay here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“My Prince,” I broke in, “I pray you suffer me to go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“My Secretary,” he answered with a note of command in his voice, “I pray you to remain where you are.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("So I sat myself on the ground after the fashion of a scribe, having no choice, and the Princess sat herself on a couch at the end of the table, but Seti remained standing. Then the Princess said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Since it is your will, Brother, that I should talk secrets into other ears than yours, I obey you. Still”—here she looked at me wrathfully—“let the tongue be careful that it does not repeat what the ears have heard, lest there should be neither ears nor tongue. My Brother, it has been reported to Pharaoh, while we ate together, that there is tumult in this town. It has been reported to him that because of a trouble about some base Israelite you caused one of his officers to be beheaded, after which there came a riot which still rages.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Strange that truth should have come to the ears of Pharaoh so quickly. Now, my Sister, if he had heard it three moons hence I could have believed you—almost.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Then you did behead the officer?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, I beheaded him about two hours ago.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Pharaoh will demand an account of the matter.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Pharaoh,” answered Seti lifting his eyes, “has no power to question the justice of the Governor of Tanis in the north.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“You are in error, Seti. Pharaoh has all power.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Nay, Sister, Pharaoh is but one man among millions of other men, and though he speaks it is their spirit which bends his tongue, while above that spirit is a yet greater spirit who decrees what they shall think to ends of which we know nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I do not understand, Seti.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I never thought you would, Userti, but when you have leisure, ask Ana here to explain the matter to you. I am sure that ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("he")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" understands.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Oh! I have borne enough,” exclaimed Userti rising. “Hearken to the command of Pharaoh, Prince Seti. It is that you wait upon him to-morrow in full council, at an hour before noon, there to talk with him of this question of the Israelitish slaves and the officer whom it has pleased you to kill. I came to speak other words to you also, but as they were for your private ear, these can bide a more fitting opportunity. Farewell, my Brother.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“What, are you going so soon, Sister? I wished to tell you the story about those Israelites, and especially of the maid whose name is—what was her name, Ana?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Merapi, Moon of Israel, Prince,” I added with a groan.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“About the maid called Merapi, Moon of Israel, I think the sweetest that ever I have looked upon, whose father the dead captain murdered in my sight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“So there is a woman in the business? Well, I guessed it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“In what business is there not a woman, Userti, even in that of a message from Pharaoh. Pambasa, Pambasa, escort the Princess and summon her servants, women everyone of them, unless my senses mock me. Good-night to you, O Sister and Lady of the Two Lands, and forgive me—that coronet of yours is somewhat awry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("At last she was gone and I rose, wiping my brow with a corner of my robe, and looking at the Prince who stood before the fire laughing softly.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Make a note of all this talk, Ana,” he said; “there is more in it than meets the ear.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I need no note, Prince,” I answered; “every word is burnt upon my mind as a hot iron burns a tablet of wood. With reason too, since now her Highness will hate me for all her life.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Much better so, Ana, than that she should pretend to love you, which she never would have done while you are my friend. Women oftimes respect those whom they hate and even will advance them because of policy, but let those whom they pretend to love beware. The time may come when you will yet be Userti’s most trusted councillor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Now here I, Ana the Scribe, will state that in after days, when this same queen was the wife of Pharaoh Saptah, I did, as it chanced, become her most trusted councillor. Moreover, in those times, yes, and even in the hour of her death, she swore from the moment her eyes first fell on me she had known me to be true-hearted and held me in esteem as no self-seeker. More, I think she believed what she said, having forgotten that once she looked upon me as her enemy. This indeed I never was, who always held her in high regard and honour as a great lady who loved her country, though one who sometimes was not wise. But as I could not foresee these things on that night of long ago, I only stared at the Prince and said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Oh! why did you not allow me to depart as your Highness said I might at the beginning? Soon or late my head will pay the price of this night’s work.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Then she must take mine with it. Listen, Ana. I kept you here, not to vex the Princess or you, but for a good reason. You know that it is the custom of the royal dynasties of Egypt for kings, or those who will be kings, to wed their near kin in order that the blood may remain the purer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, Prince, and not only among those who are royal. Still, I think it an evil custom.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“As I do, since the race wherein it is practised grows ever weaker in body and in mind; which is why, perhaps, my father is not what his father was and I am not what my father is.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Also, Prince, it is hard to mingle the love of the sister and of the wife.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Very hard, Ana; so hard that when it is attempted both are apt to vanish. Well, our mothers having been true royal wives, though hers died before mine was wedded by my father, Pharaoh desires that I should marry my half-sister, Userti, and what is worse, she desires it also. Moreover, the people, who fear trouble ahead in Egypt if we, who alone are left of the true royal race born of queens, remain apart and she takes another lord, or I take another wife, demand that it should be brought about, since they believe that whoever calls Userti the Strong his spouse will one day rule the land.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Why does the Princess wish it—that she may be a queen?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, Ana, though were she to wed my cousin, Amenmeses, the son of Pharaoh’s elder brother Khaemuas, she might still be a queen, if I chose to stand aside as I would not be loth to do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Would Egypt suffer this, Prince?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I do not know, nor does it matter since she hates Amenmeses, who is strong-willed and ambitious, and will have none of him. Also he is already married.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Is there no other royal one whom she might take, Prince?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“None. Moreover she wishes me alone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Why, Prince?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Because of ancient custom which she worships. Also because she knows me well and in her fashion is fond of me, whom she believes to be a gentle-minded dreamer that she can rule. Lastly, because I am the lawful heir to the Crown and without me to share it, she thinks that she would never be safe upon the Throne, especially if I should marry some other woman, of whom she would be jealous. It is the Throne she desires and would wed, not the Prince Seti, her half-brother, whom she takes with it to be in name her husband, as Pharaoh commands that she should do. Love plays no part in Userti’s breast, Ana, which makes her the more dangerous, since what she seeks with a cold heart of policy, that she will surely find.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Then it would seem, Prince, that the cage is built about you. After all it is a very splendid cage and made of gold.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, Ana, yet not one in which I would live. Still, except by death how can I escape from the threefold chain of the will of Pharaoh, of Egypt, and of Userti? Oh!” he went on in a new voice, one that had in it both sorrow and passion, “this is a matter in which I would have chosen for myself who in all others must be a servant. And I may not choose!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Is there perchance some other lady, Prince?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“None! By Hathor, none—at least I think not. Yet I would have been free to search for such a one and take her when I found her, if she were but a fishergirl.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“The Kings of Egypt can have large households, Prince.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I know it. Are there not still scores whom I should call aunt and uncle? I think that my grandsire, Rameses, blessed Egypt with quite three hundred children, and in so doing in a way was wise, since thus he might be sure that, while the world endures, in it will flow some of the blood that once was his.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yet in life or death how will that help him, Prince? Some must beget the multitudes of the earth, what does it matter who these may have been?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Nothing at all, Ana, since by good or evil fortune they are born. Therefore, why talk of large households? Though, like any man who can pay for it, Pharaoh may have a large household, I seek a queen who shall reign in my heart as well as on my throne, not a ‘large household,’ Ana. Oh! I am weary. Pambasa, come hither and conduct my secretary, Ana, to the empty room that is next to my own, the painted chamber which looks toward the north, and bid my slaves attend to all his wants as they would to mine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Why did you tell me you were a scribe, my lord Ana?” asked Pambasa, as he led me to my beautiful sleeping-place.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Because that is my trade, Chamberlain.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He looked at me, shaking his great head till the long white beard waved across his breast like a temple banner in the faint evening breeze, and answered:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“You are no scribe, you are a magician who can win the love and favour of his Highness in an hour which others cannot do between two risings of the Nile. Had you said so at once, you would have been differently treated yonder in the hall of waiting. Forgive me therefore what I did in ignorance, and, my lord, I pray it may please you not to melt away in the night, lest my feet should answer for it beneath the sticks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It was the fourth hour from sunrise of the following day that, for the first time in my life I found myself in the Court of Pharaoh standing with other members of his household in the train of his Highness, the Prince Seti. It was a very great place, for Pharaoh sat in the judgment hall, whereof the roof is upheld by round and sculptured columns, between which were set statues of Pharaohs who had been. Save at the throne end of the hall, where the light flowed down through clerestories, the vast chamber was dim almost to darkness; at least so it seemed to me entering there out of the brilliant sunshine. Through this gloom many folk moved like shadows; captains, nobles, and state officers who had been summoned to the Court, and among them white-robed and shaven priests. Also there were others of whom I took no count, such as Arab headmen from the desert, traders with jewels and other wares to sell, farmers and even peasants with petitions to present, lawyers and their clients, and I know not who besides, though of all these none were suffered to advance beyond a certain mark where the light began to fall. Speaking in whispers all of these folk flitted to and fro like bats in a tomb.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("We waited between two Hathor-headed pillars in one of the vestibules of the hall, the Prince Seti, who was clad in purple-broidered garments and wore upon his brow a fillet of gold from which rose the uræus or hooded snake, also of gold, that royal ones alone might wear, leaning against the base of a statue, while the rest of us stood silent behind him. For a time he was silent also, as a man might be whose thoughts were otherwhere. At length he turned and said to me:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“This is weary work. Would I had asked you to bring that new tale of yours, Scribe Ana, that we might have read it together.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Shall I tell you the plot of it, Prince?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes. I mean, not now, lest I should forget my manners listening to you. Look,” and he pointed to a dark-browed, fierce-eyed man of middle age who passed up the hall as though he did not see us, “there goes my cousin, Amenmeses. You know him, do you not?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("I shook my head.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Then tell me what you think of him, at once before the first judgment fades.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I think he is a royal-looking lord, obstinate in mind and strong in body, handsome too in his way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“All can see that, Ana. What else?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I think,” I said in a low voice so that none might overhear, “that his heart is as black as his brow; that he has grown wicked with jealousy and hate and will do you evil.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Can a man grow wicked, Ana? Is he not as he was born till the end? I do not know, nor do you. Still you are right, he is jealous and will do me evil if it brings him good. But tell me, which of us will triumph at the last?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("While I hesitated what to answer I became aware that someone had joined us. Looking round I perceived a very ancient man clad in a white robe. He was broad-faced and bald-headed, and his eyes burned beneath his shaggy eyebrows like two coals in ashes. He supported himself on a staff of cedar-wood, gripping it with both hands that for thinness were like to those of a mummy. For a while he considered us both as though he were reading our souls, then said in a full and jovial voice:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Greeting, Prince.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Seti turned, looked at him, and answered:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Greeting, Bakenkhonsu. How comes it that you are still alive? When we parted at Thebes I made sure—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“That on your return you would find me in my tomb. Not so, Prince, it is I who shall live to look upon you in your tomb, yes, and on others who are yet to sit in the seat of Pharaoh. Why not? Ho! ho! Why not, seeing that I am but a hundred and seven, I who remember the first Rameses and have played with his grandson, your grandsire, as a boy? Why should I not live, Prince, to nurse your grandson—if the gods should grant you one who as yet have neither wife nor child?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Because you will get tired of life, Bakenkhonsu, as I am already, and the gods will not be able to spare you much longer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“The gods can endure yet a while without me, Prince, when so many are flocking to their table. Indeed it is their desire that one good priest should be left in Egypt. Ki the Magician told me so only this morning. He had it straight from Heaven in a dream last night.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Why have you been to visit Ki?” asked Seti, looking at him sharply. “I should have thought that being both of a trade you would have hated each other.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Not so, Prince. On the contrary we add up each other’s account; I mean, check and interpret each other’s visions, with which we are both of us much troubled just now. Is that young man a scribe from Memphis?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, and my friend. His grandsire was Pentaur the poet.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Indeed. I knew Pentaur well. Often has he read me to sleep with his long poems, rank stuff that grew like coarse grass upon a deep but half-drained soil. Are you sure, young man, that Pentaur was your grandfather? You are not like him. Quite a different kind of herbage, and you know that it is a matter upon which we must take a woman’s word.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Seti burst out laughing and I looked at the old priest angrily, though now that I came to think of it my father always said that his mother was one of the biggest liars in Egypt.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Well, let it be,” went on Bakenkhonsu, “till we find out the truth before Thoth. Ki was speaking of you, young man. I did not pay much attention to him, but it was something about a sudden vow of friendship between you and the Prince here. There was a cup in the story too, an alabaster cup that seemed familiar to me. Ki said it was broken.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Seti started and I began angrily:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“What do you know of that cup? Where were you hid, O Priest?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Oh, in your souls, I suppose,” he answered dreamily, “or rather Ki was. But I know nothing, and am not curious. If you had broken the cup with a woman now, it would have been more interesting, even to an old man. Be so good as to answer the Prince’s question as to whether he or his cousin Amenmeses will triumph at the last, for on that matter both Ki and I are curious.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Am I a seer,” I began again still more angrily, “that I should read the future?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I think so, a little, but that is what I want to find out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He hobbled towards me, laid one of his claw-like hands upon my arm, and said in a new voice of command:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Look now upon that throne and tell me what you see there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("I obeyed him because I must, staring up the hall at the empty throne. At first I saw nothing. Then figures seemed to flit around it. From among these figures emerged the shape of the Count Amenmeses. He sat upon the throne, looking about him proudly, and I noted that he was no longer clad as a prince but as Pharaoh himself. Presently hook-nosed men appeared who dragged him from his seat. He fell, as I thought, into water, for it seemed to splash up above him. Next Seti the Prince appeared to mount the throne, led thither by a woman, of whom I could only see the back. I saw him distinctly wearing the double crown and holding a sceptre in his hand. He also melted away and others came whom I did not know, though I thought that one of them was like to the Princess Userti.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Now all were gone and I was telling Bakenkhonsu everything I had witnessed like a man who speaks in his sleep, not by his own will. Suddenly I woke up and laughed at my own foolishness. But the other two did not laugh; they regarded me very gravely.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I thought that you were something of a seer,” said the old priest, “or rather Ki thought it. I could not quite believe Ki, because he said that the young person whom I should find with the Prince here this morning would be one who loved him with all the heart, and it is only a woman who loves with all the heart, is it not? Or so the world believes. Well, I will talk the matter over with Ki. Hush! Pharaoh comes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("As he spoke from far away rose a cry of—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Life! Blood! Strength! Pharaoh! Pharaoh! Pharaoh!”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e30d20b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled321.vue
// module id = 78
// module chunks = 0